import { render, staticRenderFns } from "./allocateloadManagement.vue?vue&type=template&id=9138537e"
import script from "./allocateloadManagement.vue?vue&type=script&lang=js"
export * from "./allocateloadManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports